import { render, staticRenderFns } from "./ServiceModel.vue?vue&type=template&id=8d19ff6c&scoped=true"
import script from "./ServiceModel.vue?vue&type=script&lang=js"
export * from "./ServiceModel.vue?vue&type=script&lang=js"
import style0 from "./ServiceModel.vue?vue&type=style&index=0&id=8d19ff6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d19ff6c",
  null
  
)

export default component.exports